/* Atomic Bear — Stealth Pen Pro offer page interactions */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('atb-lp');
    if (!root) return;

    /* ---------- Countdown ---------- */
    (function () {
      var el = document.getElementById('atb-countdown');
      if (!el) return;
      var dur = (2 * 3600 + 6 * 60 + 18) * 1000;
      var KEY = 'atb_cd_end_v1';
      var end = parseInt(localStorage.getItem(KEY), 10);
      if (!end || end < Date.now()) { end = Date.now() + dur; localStorage.setItem(KEY, end); }
      var h = el.querySelector('[data-cd="h"]');
      var m = el.querySelector('[data-cd="m"]');
      var s = el.querySelector('[data-cd="s"]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { end = Date.now() + dur; localStorage.setItem(KEY, end); diff = dur; }
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        if (h) h.textContent = pad(hh);
        if (m) m.textContent = pad(mm);
        if (s) s.textContent = pad(ss);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---------- Gallery ---------- */
    (function () {
      var main = document.getElementById('atb-gallery-main');
      var thumbs = document.getElementById('atb-thumbs');
      if (!main || !thumbs) return;
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.atb-thumb');
        if (!btn) return;
        var img = btn.querySelector('img');
        if (img) main.src = img.getAttribute('data-full') || img.src;
        thumbs.querySelectorAll('.atb-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
      // swipe on the main image cycles prev/next (mobile), kept in sync with the thumb slider
      function goTo(i) {
        var list = Array.prototype.slice.call(thumbs.querySelectorAll('.atb-thumb'));
        if (!list.length) return;
        i = (i + list.length) % list.length;
        var btn = list[i];
        var img = btn.querySelector('img');
        if (img) main.src = img.getAttribute('data-full') || img.src;
        list.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      var swX = 0, swY = 0;
      main.addEventListener('touchstart', function (e) { swX = e.touches[0].clientX; swY = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var list = Array.prototype.slice.call(thumbs.querySelectorAll('.atb-thumb'));
        var cur = list.indexOf(thumbs.querySelector('.atb-thumb.is-active'));
        goTo(dx < 0 ? cur + 1 : cur - 1);
      }, { passive: true });
      // thumbnail slider arrows: shown only when the row overflows / not at an edge
      var wrap = thumbs.closest('.atb-gallery__thumbwrap');
      if (wrap) {
        var prevBtn = wrap.querySelector('.atb-thumb-nav--prev');
        var nextBtn = wrap.querySelector('.atb-thumb-nav--next');
        function syncNav() {
          var sl = thumbs.scrollLeft, max = thumbs.scrollWidth - thumbs.clientWidth, has = max > 2;
          if (prevBtn) prevBtn.hidden = !has || sl <= 2;
          if (nextBtn) nextBtn.hidden = !has || sl >= max - 2;
        }
        if (prevBtn) prevBtn.addEventListener('click', function () { thumbs.scrollBy({ left: -thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { thumbs.scrollBy({ left: thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
        thumbs.addEventListener('scroll', syncNav, { passive: true });
        window.addEventListener('resize', syncNav);
        syncNav();
      }
    })();

    /* ---------- Bundle selector ---------- */
    var selectedQty = 1;
    (function () {
      var wrap = document.getElementById('atb-bundles');
      if (!wrap) return;
      var nameEl = document.getElementById('atb-bundle-name');
      var pppEl = document.getElementById('atb-bundle-ppp');
      var nowEl = document.getElementById('atb-price-now');
      var wasEl = document.getElementById('atb-price-was');
      var badgeEl = document.getElementById('atb-price-badge');
      var gifts = document.querySelectorAll('.atb-gift[data-gift-min]');
      function select(btn) {
        wrap.querySelectorAll('.atb-bundle').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedQty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        // lock/unlock the free gifts by bundle size (refill needs 3+, class needs 5)
        gifts.forEach(function (g) { g.classList.toggle('is-locked', selectedQty < parseInt(g.getAttribute('data-gift-min'), 10)); });
        if (nameEl) nameEl.textContent = btn.getAttribute('data-name');
        if (pppEl) pppEl.textContent = btn.getAttribute('data-ppp');
        // update the headline price/strikethrough/badge to match the selected bundle
        var now = btn.getAttribute('data-now'), was = btn.getAttribute('data-was'), badge = btn.getAttribute('data-badge');
        if (nowEl && now) nowEl.textContent = now;
        // keep the price block the same height across bundles (reserve space with visibility) so the section doesn't jump
        if (wasEl) { wasEl.textContent = was || ' '; wasEl.style.visibility = was ? 'visible' : 'hidden'; }
        if (badgeEl) { badgeEl.textContent = badge || ' '; badgeEl.style.visibility = badge ? 'visible' : 'hidden'; }
      }
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.atb-bundle');
        if (btn) select(btn);
      });
      // initialise from the active bundle (default 3-PACK) so the price is in sync on load
      var initial = wrap.querySelector('.atb-bundle.is-active') || wrap.querySelector('.atb-bundle[data-qty="3"]') || wrap.querySelector('.atb-bundle');
      if (initial) select(initial);
    })();

    /* ---------- Accordions (product + faq) ---------- */
    root.querySelectorAll('.atb-acc').forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        var head = e.target.closest('.atb-acc__head');
        if (!head) return;
        var item = head.closest('.atb-acc__item');
        if (item) item.classList.toggle('is-open');
      });
    });
    // FEATURES open by default on mobile only (matches the mobile Figma frame)
    if (window.matchMedia('(max-width: 900px)').matches) {
      var featOpen = root.querySelector('.atb-acc__item[data-open-mobile]');
      if (featOpen) featOpen.classList.add('is-open');
    }

    /* ---------- Testimonial carousel ---------- */
    (function () {
      var track = document.getElementById('atb-testi-track');
      var dotsWrap = document.getElementById('atb-testi-dots');
      if (!track) return;
      var slides = track.children.length;
      var i = 0;
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      root.querySelectorAll('[data-testi]').forEach(function (b) {
        b.addEventListener('click', function () { go(b.getAttribute('data-testi') === 'next' ? i + 1 : i - 1); });
      });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      go(0);
    })();

    /* ---------- Comparison carousel (mobile, swipe + dots) ---------- */
    (function () {
      var track = document.getElementById('atb-ctrack');
      var dotsWrap = document.getElementById('atb-cdots');
      if (!track || !dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.children);
      var n = track.children.length;
      function update() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        i = Math.max(0, Math.min(n - 1, i));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      track.addEventListener('scroll', update, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
      update();
    })();

    /* ---------- Trouble-section videos: play in view, pause off-screen ---------- */
    (function () {
      var vids = document.querySelectorAll('.atb-tcol__vid');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    })();

    /* ---------- Show more reviews ---------- */
    (function () {
      var btn = document.querySelector('.atb-reviews__more button');
      var grid = document.getElementById('atb-masonry');
      if (!btn || !grid) return;
      var expanded = false;
      btn.addEventListener('click', function () {
        if (expanded) return;
        var clone = grid.cloneNode(true);
        Array.prototype.forEach.call(clone.children, function (c) { grid.appendChild(c.cloneNode(true)); });
        expanded = true;
        btn.style.display = 'none';
      });
    })();

    /* ---------- Add to cart ---------- */
    function addToCart(variantId, qty, button) {
      if (!variantId) { window.location.href = '/checkout'; return; }
      if (button) { button.classList.add('is-loading'); }
      var items = [{ id: Number(variantId), quantity: qty || 1 }];
      // include the unlocked free gifts (the store's automatic gift discounts make them $0 in checkout)
      document.querySelectorAll('.atb-gift[data-gift-min][data-variant]:not(.is-locked)').forEach(function (g) {
        items.push({ id: Number(g.getAttribute('data-variant')), quantity: 1 });
      });
      // clear the cart first so checkout only contains the bundle picked here (no stale items stacking)
      fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (r) {
        window.location.href = r.ok ? '/checkout' : '/cart';
      }).catch(function () { window.location.href = '/cart'; });
    }
    var atc = document.getElementById('atb-atc');
    if (atc) atc.addEventListener('click', function () { addToCart(atc.getAttribute('data-variant'), selectedQty, atc); });
    // reset the ATC loading state when the page is restored from the back/forward cache (clicking browser-back after redirect to checkout)
    window.addEventListener('pageshow', function () { if (atc) atc.classList.remove('is-loading'); });

    /* ---------- Smooth-scroll triggers (rating -> reviews, final CTAs -> buy box) ---------- */
    document.querySelectorAll('[data-scrollto]').forEach(function (el) {
      function go(e) { var t = document.querySelector(el.getAttribute('data-scrollto')); if (t) { if (e) e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(e); } });
    });
  });
})();
